import React from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import TMELogsTable from "../../components/trainer-member-engagement/TMELogsTable";

const TMELogs = () => {
  const authData = useSelector(selectUser);
  const userInfoData = authData || {};

  return (
    <HelmetWrapper title="WTF: Trainer and Member Engagement">
      <Container className="bg-cloud-k px-50px" fluid>
        <TMELogsTable userInfoData={userInfoData} />
      </Container>
    </HelmetWrapper>
  );
};

export default TMELogs;
